import Cookies from "js-cookie";
import { InfoAlert } from "./SweetAlerts.jsx";
import { config } from "./CommonURLS";
import axios from "axios";
import { getTokenExpiry } from "./TimeUtility.js";

import { hideLoader, showLoader } from "../Reducers/LoaderActions.jsx";
// import { store } from "../store/Store.jsx";

// import { clearAuthSession } from "./RequireAuth.jsx";
import { store } from "../store/index.jsx";



let isRefreshing = false;
let refreshPromise = null;

const Refreshmethod = async (url, values, method) => {
  try {
    if (isRefreshing && refreshPromise) {
      await refreshPromise;
      return method === "get"
        ? CommonAxiosGet(url, values)
        : CommonAxiosPost(url, values);
    }

    isRefreshing = true;
    const refreshToken = sessionStorage.getItem("refreshToken");
    if (!refreshToken) {
      console.log("❌ No refresh token found");
      return logoutUser();
    }
    const URL = config.url.STU_URL + "auth/refresh-token";

    refreshPromise = axios.post(URL, { refreshToken });

    const res = await refreshPromise;

    // ✅ Validate response
    if (!res?.data?.accessToken) {
      console.log("❌ Invalid refresh response", res);
      return logoutUser();
    }

    const acToken = res.data.accessToken;
    const rfToken = res.data.refreshToken;

    // Cookies.set("token", acToken);
    // Cookies.set("refreshToken", rfToken);
    // Cookies.set("tokenTime", getTokenExpiry(acToken));
    // Cookies.set("refreshTokenTime", getTokenExpiry(rfToken));

    sessionStorage.setItem("token", acToken);
    sessionStorage.setItem("refreshToken", rfToken);
    sessionStorage.setItem("tokenTime", getTokenExpiry(acToken));
    sessionStorage.setItem("refreshTokenTime", getTokenExpiry(rfToken));

    return method === "get"
      ? CommonAxiosGet(url, values)
      : CommonAxiosPost(url, values);

  } catch (err) {
    console.error("❌ Refresh API error", err);

    // ✅ Logout only if refresh API truly failed
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      return logoutUser();
    }

    // ⛔ Network error → don't logout immediately
    InfoAlert("Network issue. Please try again.", "warning");
    throw err;

  } finally {
    isRefreshing = false;
    refreshPromise = null;
  }
};

const logoutUser = () => {
  // clearAuthSession();
  // Cookies.remove("token");
  // Cookies.remove("refreshToken");
  window.location.replace("/");
};



/* ---------------- ERROR HANDLER ---------------- */

export const catchErrorMessages = async (err, url, values, method) => {
  if (err?.response?.status === 401) {
    return await Refreshmethod(url, values, method);
  }
  if (err?.response?.status === 500) {
    InfoAlert("Internal Server Error, Try After Sometime", "warning");
  }
  if (err?.response?.status === 404) {
    InfoAlert("Page Not Found", "warning");
  }
  if (err?.response?.status === 504) {
    InfoAlert("Timed Out", "warning");
  }
};

/* ---------------- POST METHOD ---------------- */

// export const CommonAxiosPost = async (url, values) => {
//   let token = Cookies.get("token");
//   let refreshToken = Cookies.get("refreshToken");
//   showLoader("rgb(66, 44, 2)");

//   let data = "";

//   try {
//     if (!token && refreshToken) {
//       return await Refreshmethod(url, values, "post");
//     }

//     if (token) {
//       const res = await axios({
//         url,
//         method: "post",
//         data: values,
//         headers: { Authorization: "Bearer " + token },
//       });

//       if (res.status === 200) data = res;
//       return data;
//     }

//   } catch (err) {
//     return catchErrorMessages(err, url, values, "post");
//   } finally {
//     hideLoader();
//   }
// };

/* ---------------- GET METHOD ---------------- */

// export const CommonAxiosGet = async (url, values) => {
//   let token = Cookies.get("token");
//   let refreshToken = Cookies.get("refreshToken");
//   showLoader("rgb(66, 44, 2)");

//   let data = "";

//   try {
//     if (!token && refreshToken) {
//       return await Refreshmethod(url, values, "get");
//     }

//     if (token) {
//       const res = await axios({
//         url,
//         method: "get",
//         headers: { Authorization: "Bearer " + token },
//       });

//       if (res.status === 200) data = res;
//       return data;
//     }

//   } catch (err) {
//     console.log("catch")
//     return catchErrorMessages(err, url, values, "get");
//   } finally {
//     hideLoader();
//   }
// };

/* ---------------- LOGIN POST (NO TOKEN) ---------------- */

export const CommonAxiosPostLogin = async (url, values) => {
  let data = "";

  try {
    const res = await axios({
      url,
      method: "post",
      data: values,
    });

    if (res.status === 200) data = res;
    return data;

  } catch (err) {
    if (err.response && err.response.status === 401) {
      data = err.response;
    }
    return data;
  }
};

export const CommonAxiosPost = async (url, values) => {

  store.dispatch(showLoader());  // ✅ show loader

  try {

    const token = sessionStorage.getItem("token");

    const res = await axios({
      url,
      method: "post",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });

    return res;

  } catch (err) {
    return catchErrorMessages(err, url, values, "post");
  } finally {
    store.dispatch(hideLoader()); // ✅ hide loader
  }
};

export const CommonAxiosGet = async (url, values) => {

  store.dispatch(showLoader());  // ✅ show

  try {

    const token = sessionStorage.getItem("token");

    const res = await axios({
      url,
      method: "get",
      headers: { Authorization: "Bearer " + token },
    });

    return res;

  } catch (err) {
    return catchErrorMessages(err, url, null, "get");
  } finally {
    store.dispatch(hideLoader()); // ✅ hide
  }
};
export const CommonAxiosPut = async (url, values) => {

  store.dispatch(showLoader());  // ✅ show loader

  try {

    const token = sessionStorage.getItem("token");

    const res = await axios({
      url,
      method: "post",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });

    return res;

  } catch (err) {
    return catchErrorMessages(err, url, values, "post");
  } finally {
    store.dispatch(hideLoader()); // ✅ hide loader
  }
};